<div class="flex flex-col gap-2 w-full">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
      @if (tooltipKey()) {
        <app-directus-tooltip class="ml-2" [tooltipKey]="tooltipKey()" />
      }
    </label>
  }

  @if (isReadOnly()) {
    <textarea
      pInputTextarea
      [id]="id()"
      [value]="readonlyText()"
      [rows]="rows()"
      [disabled]="true"
      class="w-full readOnly"
    ></textarea>
  } @else {
    <textarea
      pInputTextarea
      [id]="id()"
      [attr.data-testid]="id() + '-input'"
      [(ngModel)]="value"
      [rows]="rows()"
      [autoResize]="autoResize()"
      [placeholder]="placeholder() || label() | transloco"
      [ngClass]="{'p-invalid': showInvalid()}"
      class="w-full"
      (blur)="markAsTouched()"
    ></textarea>
  }
</div>
